import { useMutation, useQuery } from 'react-query';
import { getTenantConfig, updateTenantConfig, type UpdateTenantConfigRequest } from '@/services/settingsService';

export function useTenantConfig() {
  return useQuery({
    queryKey: ['tenant-config'],
    queryFn: async () => {
      const res = await getTenantConfig();
      return res.data;
    },
    enabled: true,
  });
}

export function useUpdateTenantConfig() {
  return useMutation({
    mutationFn: async (payload: UpdateTenantConfigRequest) => {
      const res = await updateTenantConfig(payload);
      return res.data;
    },
  });
}
